import Sticky from '../classes/Sticky';

class StickiesModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.initStickies();
        this.bindEvents();
        this.bindSpecialEvents();
    }

    bindUI() {
        this.ui = {};

        this.ui.$win = window;

        this.ui.$stickies = document.querySelectorAll('.js-sticky');
    }

    bindEvents() {
        if (this.stickies.length) {
            this.ui.$win.addEventListener('scroll', this.onScroll.bind(this));
            this.ui.$win.addEventListener('resize', this.update.bind(this));
            document.body.addEventListener('lazy:done', this.update.bind(this));
        }
    }

    bindSpecialEvents() {
        document.body.addEventListener('lazy:done', this.initStickies.bind(this));

        if (this.stickies.length) {
            document.body.addEventListener('carousel:fullyRdy', this.update.bind(this));
            document.body.addEventListener('goto:start', this.update.bind(this));
        }
    }

    initStickies() {
        this.stickies = [];

        [].forEach.call(this.ui.$stickies, (sticky, index) => {
            const offsetAttribute = sticky.getAttribute('data-offset') * 1;

            this.stickies.push(
                new Sticky({
                    el: sticky,
                    contained: true,
                    parent: '.js-sticky-ref',
                    offsetTop: offsetAttribute
                })
            );
        });
    }

    onScroll() {
        let doc = document.documentElement,
            scrollTop = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);

        this.stickies.forEach((sticky, index) => {
            sticky.checkScroll(scrollTop);
        });
    }

    update() {
        let doc = document.documentElement,
            scrollTop = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);

        this.stickies.forEach((sticky, index) => {
            sticky.update(scrollTop);
        });
    }
}

export default StickiesModule;
